import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { error } from 'jquery';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { IStudyUnitDisplayOrder } from '../../content-management/study-unit-display-order/study-unit-display-order.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assign-studyunit-to-practice-test',
  templateUrl: './assign-studyunit-to-practice-test.component.html',
  styleUrls: ['./assign-studyunit-to-practice-test.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AssignStudyunitToPracticeTestComponent implements OnInit {
  @Input()subjectId: number;
  @Input() courseId: number;
  studyUnits: IStudyUnitDisplayOrder[] = [];
  selectedUnitId: number | null = null; // Holds the ID of the selected study unit
  highlightedUnitId: number | null = null; // Holds the ID of the selected study unit
  constructor(
    public activeModal: NgbActiveModal,
    private contentService: ContentManagementService ,
    private readonly toaster: ToastrService,
  ) {}
  ngOnInit(): void{
    this.getStudyUnitList()
  }

  getStudyUnitList(){
    const payload= {
      Subject_ID: this.subjectId,
      Course_Id: this.courseId,
    }
    this.contentService.getStudyUnitsDisplayOrder(payload).subscribe(
      (res)=>{
        console.log(res,"studyUniList");
        this.studyUnits = [...res].sort(
          (a, b) =>
            (a.Major_Topic_Sort_Order ?? 0) - (b.Major_Topic_Sort_Order ?? 0) ||
            (a.Study_unit_Display_Order ?? 0) - (b.Study_unit_Display_Order ?? 0)
        );
        
      },
      (error)=>{}
    )
  }
  save() {
    if (!this.selectedUnitId) {
      this.toaster.error('Please select a study unit.');
      return;
    }
    // Find the selected unit object
    const selectedUnit = this.studyUnits.find(u => u.Study_Unit_Id === this.selectedUnitId);
  
    if (!selectedUnit) {
      this.toaster.error('Selected study unit not found.');
      return;
    }
  
    // Pass back an object with the fields you need
    this.activeModal.close({
      id: selectedUnit.Study_Unit_Id,
      name: selectedUnit.Study_Unit_Name,
      topic: selectedUnit.Path_Name
    });
  }
  
  highlightUnit(id: number) {
    this.selectedUnitId = id;
    this.highlightedUnitId = id;
  }
  

  selectUnit(unitId: number) {
    console.log(unitId);
    
    this.selectedUnitId = unitId;
    const selectedUnit = this.studyUnits.find(u => u.Study_Unit_Id === unitId);
    if(selectedUnit){
    this.activeModal.close({
      id: selectedUnit.Study_Unit_Id,
      name: selectedUnit.Study_Unit_Name,
      topic: selectedUnit.Path_Name
    });
  }
  }
}
